<template>
  <v-layout>
    <v-flex sm12 class="ma-0 pa-0">
      <v-btn
        :class="`ml-0 menu-tab ${active == 0 && 'active'}`"
        @click="
          active == 0 || $router.push(`/project/${$route.params.id}/responses`)
        "
      >
        Responses
      </v-btn>
      <v-btn
        v-if="agent_option != 3"
        :class="`menu-tab ${active == 1 && 'active'}`"
        @click="
          active == 1 || $router.push(`/project/${$route.params.id}/summary`)
        "
      >
        Project Summary
      </v-btn>
      <v-btn
        :class="`menu-tab ${active == 2 && 'active'}`"
        @click="
          active == 2 || $router.push(`/project/${$route.params.id}/preview`)
        "
      >
        Preview
      </v-btn>
      <v-btn
        :class="`menu-tab ${active == 3 && 'active'}`"
        @click="
          active == 3 ||
            $router.push(`/project/${$route.params.id}/project-settings`)
        "
      >
        Project Settings
      </v-btn>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["active"],
  computed: {
    ...mapGetters(["indexData"]),
  },
  data() {
    return {
      agent_option: null,
    };
  },
  created() {
    this.agent_option = this.indexData.projectData
      ? this.indexData.projectData.agent_option
      : null;
  },
};
</script>
<style scoped>
.menu-tab {
  color: #333;
  background: #ddd !important;
}
.menu-tab.active {
  color: #fff;
  background: #f66 !important;
}
</style>
